module.exports = __webpack_public_path__ + "img/pause.a8d5a28e.png";